// extracted by mini-css-extract-plugin
module.exports = {"expertDataReviews":"_2JO0s","title":"QgiFr","content":"_3vK5_","contentSection":"_3ry7q","toggleReadMore":"_1xZT2","subTitle":"_2GLdj","text":"_1p83Y","showMoreReviews":"_3z1Zx"};